import React, { useState, useEffect } from 'react';
import api from '../services/apiService';
import { Helmet } from 'react-helmet';

const PipelineStageForm = ({ pipelineDefId }) => {
  const [stages, setStages] = useState([]);
  const [newStage, setNewStage] = useState({
    name: '',
    order: 0,
    color: '',
    isWon: false,
    isLost: false,
    probability: '',
    pipelineDefId: pipelineDefId || null,
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingStage, setEditingStage] = useState(null);
  const [pipelines, setPipelines] = useState([]);

useEffect(() => {
  if (!pipelineDefId) {
    api.get('/pipeline-definitions')
      .then(res => setPipelines(res.data))
      .catch(() => setPipelines([]));
  }
}, [pipelineDefId]);

  // Stages abrufen und sortieren
  useEffect(() => {
    const fetchStages = async () => {
      try {
        const response = await api.get('/pipeline-stages', {
          params: pipelineDefId ? { pipelineDefId } : {}
        });
        const sorted = response.data.sort((a, b) =>
  (a.pipelineDefinition?.name || '').localeCompare(b.pipelineDefinition?.name || '') ||
  a.order - b.order
);
setStages(sorted);
      } catch (err) {
        setError('Fehler beim Abrufen der Stages');
      } finally {
        setLoading(false);
      }
    };
    fetchStages();
  }, [pipelineDefId]);

  // Neue Stage anlegen
  const handleAddStage = async () => {
    const { name, order, color, isWon, isLost, probability } = newStage;
    if (!name) {
      alert('Bitte den Namen der Phase angeben.');
      return;
      }
if (!(pipelineDefId || newStage.pipelineDefId)) {
  alert('Bitte wählen Sie eine Pipeline aus.');
  return;
    }
    try {
      const payload = {
        ...newStage,
        pipelineDefId: pipelineDefId || newStage.pipelineDefId,
        probability: probability !== '' ? Number(probability) : null,
      };
      const response = await api.post('/pipeline-stages', payload);
      const updatedList = [...stages, response.data].sort((a, b) => a.order - b.order);
      setStages(updatedList);
      setNewStage({ name: '', order: 0, color: '', isWon: false, isLost: false, probability: '', pipelineDefId });
    } catch (err) {
      alert('Fehler beim Hinzufügen der Stage');
    }
  };

  // Stage löschen
  const handleDeleteStage = async (id) => {
    if (!window.confirm('Möchten Sie diese Phase wirklich löschen?')) return;
    try {
      await api.delete(`/pipeline-stages/${id}`);
      setStages(stages.filter(stage => stage.id !== id));
    } catch (err) {
      alert('Fehler beim Löschen der Stage');
    }
  };

  // Bearbeiten starten
  const handleEditClick = (stage) => {
    setEditingStage({ ...stage });
  };

  // Bearbeitung abbrechen
  const handleCancelEdit = () => {
    setEditingStage(null);
  };

  // Änderungen bei Eingaben übernehmen
  const handleEditInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setEditingStage(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Speichern der Änderungen
  const handleSaveStage = async () => {
    const { id, name, order, color, isWon, isLost, probability } = editingStage;
    if (!name) {
      alert('Bitte den Namen der Phase angeben.');
      return;
    }
    try {
      const payload = {
        name,
        order,
        color,
        isWon,
        isLost,
        probability: probability !== '' ? Number(probability) : null,
        pipelineDefId,
      };
      const response = await api.put(`/pipeline-stages/${id}`, payload);
      const updatedList = stages.map(s => s.id === id ? response.data : s).sort((a, b) => a.order - b.order);
      setStages(updatedList);
      setEditingStage(null);
    } catch (err) {
      alert('Fehler beim Aktualisieren der Stage');
    }
  };

  if (loading) return <div>Lade Phasen...</div>;
  if (error) return <div>{error}</div>;

  // Styles
  const buttonStyle = { fontSize: '15px', padding: '5px 10px', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', marginRight: '5px' };
  const addButtonStyle = { ...buttonStyle, background: '#28a745' };
  const editButtonStyle = { ...buttonStyle, background: '#007bff' };
  const saveButtonStyle = { ...buttonStyle, background: '#28a745' };
  const cancelButtonStyle = { ...buttonStyle, background: '#6c757d' };
  const deleteButtonStyle = { ...buttonStyle, background: '#dc3545' };

  return (
    <div>
      <Helmet>
        <title>Pipelines: Phasen verwalten</title>
        <meta name="description" content="CRM Pipeline-Phasen verwalten" />
      </Helmet>
      <h2>Pipelines: Phasen</h2>

      {/* Formular für neue Stage */}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'center', marginBottom: '10px', marginLeft: '280px', width: '70%' }}>
        <input
          type="text"
          value={newStage.name}
          onChange={(e) => setNewStage({ ...newStage, name: e.target.value })}
          placeholder="Phasenname"
        />
        {/* Pipeline-Auswahl nur anzeigen, wenn pipelineDefId NICHT als Prop kommt */}
{!pipelineDefId && (
  <select
    value={newStage.pipelineDefId || ''}
    onChange={e => setNewStage({ ...newStage, pipelineDefId: Number(e.target.value) })}
  >
    <option value="">Pipeline wählen</option>
    {pipelines.map(p => (
      <option key={p.id} value={p.id}>{p.name}</option>
    ))}
  </select>
)}
        <input
          type="number"
          value={newStage.order}
          onChange={(e) => setNewStage({ ...newStage, order: Number(e.target.value) })}
          placeholder="Sortierung"
          min={0}
        />
        <input
          type="color"
          value={newStage.color || '#ffffff'}
          onChange={(e) => setNewStage({ ...newStage, color: e.target.value })}
          style={{ width: 35, height: 35, padding: 0, border: '1px solid #ddd' }}
          title="Farbe für die Stage"
        />
        <label>
          <input
            type="checkbox"
            checked={newStage.isWon}
            onChange={(e) => setNewStage({ ...newStage, isWon: e.target.checked })}
            style={{ marginRight: 5 }}
          />
          Gewonnen
        </label>
        <label>
          <input
            type="checkbox"
            checked={newStage.isLost}
            onChange={(e) => setNewStage({ ...newStage, isLost: e.target.checked })}
            style={{ marginRight: 5 }}
          />
          Verloren
        </label>
        <input
          type="number"
          value={newStage.probability}
          onChange={(e) => setNewStage({ ...newStage, probability: e.target.value })}
          placeholder="Wahrscheinlichkeit %"
          min={0}
          max={100}
          style={{ width: 100 }}
        />
        <button onClick={handleAddStage} style={addButtonStyle}>
          Hinzufügen
        </button>
      </div>

      {/* Tabelle mit Stages */}
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Pipeline</th>
            <th>Name</th>
            <th>Sortierung</th>
            <th>Farbe</th>
            <th>Gewonnen</th>
            <th>Verloren</th>
            <th>Wahrscheinlichkeit (%)</th>
            <th>Aktionen</th>
          </tr>
        </thead>
        <tbody>
          {stages.map(s => (
            <tr key={s.id}>
              <td>{s.id}</td>
              <td>{s.pipelineDefinition?.name || '-'}</td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="text"
                    name="name"
                    value={editingStage.name}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  s.name
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="number"
                    name="order"
                    value={editingStage.order}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  s.order
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="color"
                    name="color"
                    value={editingStage.color || '#ffffff'}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  <span style={{ display: 'inline-block', width: 25, height: 25, background: s.color || '#fff', border: '1px solid #ccc' }} />
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="checkbox"
                    name="isWon"
                    checked={!!editingStage.isWon}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  s.isWon ? '✅' : '❌'
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="checkbox"
                    name="isLost"
                    checked={!!editingStage.isLost}
                    onChange={handleEditInputChange}
                  />
                ) : (
                  s.isLost ? '✅' : '❌'
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <input
                    type="number"
                    name="probability"
                    value={editingStage.probability}
                    onChange={handleEditInputChange}
                    min={0}
                    max={100}
                  />
                ) : (
                  s.probability != null ? s.probability : '-'
                )}
              </td>
              <td>
                {editingStage?.id === s.id ? (
                  <>
                    <button onClick={handleSaveStage} style={saveButtonStyle}>Speichern</button>
                    <button onClick={handleCancelEdit} style={cancelButtonStyle}>Abbrechen</button>
                  </>
                ) : (
                  <>
                    <button onClick={() => handleEditClick(s)} style={editButtonStyle}>Bearbeiten</button>
                    <button onClick={() => handleDeleteStage(s.id)} style={deleteButtonStyle}>Löschen</button>
                  </>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PipelineStageForm;
